import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Container,
  Box,
  Typography,
  MenuItem,
} from "@mui/material";
import { Update_To_MongoDB_By_ID } from "../../api/Update_To_MongoDB_By_ID";
import { StaffuseAuth } from "../../security/StaffuseAuth";

function ChangePassword() {
  const { logout } = StaffuseAuth();
  //The below is the state for the form
  const [User, setUser] = useState({
    _id: localStorage.getItem("_id"),
    Password: "",
    Confirm_Password: "",
  });

  const handleChange = (prop) => (event) => {
    setUser({ ...User, [prop]: event.target.value });
  };

  //The below is the state for the Submit button
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    Update_To_MongoDB_By_ID(
      { Password: User.Password },
      "Staff",
      "Users",
      setIsSubmitting,
      User._id,
      logout
    );
  };

  const [isFormValid, setIsFormValid] = useState(false);

  //The below is the useEffect to check if the form is valid
  useEffect(() => {
    // Check if all required fields are filled out
    const checkFormValidity = () => {
      return (
        User.Password !== "" &&
        User._id !== "" &&
        User.Password === User.Confirm_Password
      );
    };

    setIsFormValid(checkFormValidity());
  }, [User]); // This effect runs whenever the school state changes

  return (
    <div style={{ backgroundColor: "#e5e5e5" }}>
      {" "}
      <div
        name="space"
        style={{ width: "100%", height: "20px", flex: "0 1 auto" }}
      ></div>
      <Container maxWidth="sm">
        <Typography variant="h6" gutterBottom>
          Change Password
        </Typography>
        <Box
          component="form"
          sx={{
            "& .MuiTextField-root": { m: 1, width: "25ch" },
          }}
          noValidate
          autoComplete="off"
          onSubmit={handleSubmit}
        >
          <TextField
            required
            id="Password"
            label="Password"
            type="password" // Add this line
            value={User.Password}
            onChange={handleChange("Password")}
          />
          <TextField
            required
            id="Confirm_Password"
            label="Confirm Password"
            type="password" // Add this line
            value={User.Confirm_Password}
            onChange={handleChange("Confirm_Password")}
          />

          <Button
            type="submit"
            variant="contained"
            sx={{ mt: 3, ml: 1 }}
            disabled={!isFormValid || isSubmitting}
          >
            {isSubmitting ? "Submitting..." : "Update Password"}
          </Button>
        </Box>
        <br></br>
      </Container>
    </div>
  );
}

export default ChangePassword;
